// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
let isShowCom = true;
let powerBIlink = '';
/** CONTACT_US_SECTION_ID — display email (data[0].link). Override per env after seed. */
let contactUsSectionId: number | null = 14;
/** PRIVACY_STATEMENT_SECTION_ID — privacy copy (data[0].subTitle). Override per env after seed. */
let privacyStatementSectionId: number | null = 15;
/** PRISM_INTRO_SECTION_ID — /prism-intro page body (data[0].subTitle). Override per env after seed. */
let prismIntroSectionId: number | null = 16;

const baseUri2 = 'https://stgmotapi.dhwaniris.in/web/api/';
let baseURL = 'https://stgidhinstepapi.dhwaniris.in/web/api/';

const origin = window.location.hostname;
const secratKey = '1234';
const captchaSecretKet = '6LdqKrMmAAAAAJ7DYHSe6wThAtPnhYyEkP099ZbP';
console.log(origin)

// UAT Origin — set contactUsSectionId after seed on UAT
if (origin === 'uatidhinstepui.dhwaniris.in') {
  baseURL = 'https://uatidhinstepapi.dhwaniris.in/web/api/';
  powerBIlink = 'https://app.powerbi.com/view?r=eyJrIjoiNjQzOGMzYzMtMDdmYi00YmNiLThmNDYtYmM0YTg4Y2JjMTExIiwidCI6IjZiZTk4NzZkLTI0NzAtNDJjYi05ZjQyLTA2MDQ1NGZhYjUzZCJ9';
  contactUsSectionId = 14;
  privacyStatementSectionId = 15;
  prismIntroSectionId = 16;
}

// Local Origin (contactUs: section 14/cms 81, privacy: section 15/cms 82, prismIntro: section 16)
if (origin === 'localhost' || origin === '127.0.0.1') {
  baseURL = 'http://localhost:3000/web/api/';
  isShowCom = true;
  powerBIlink = 'https://app.powerbi.com/view?r=eyJrIjoiNjQzOGMzYzMtMDdmYi00YmNiLThmNDYtYmM0YTg4Y2JjMTExIiwidCI6IjZiZTk4NzZkLTI0NzAtNDJjYi05ZjQyLTA2MDQ1NGZhYjUzZCJ9';
  contactUsSectionId = 14;
  privacyStatementSectionId = 15;
  prismIntroSectionId = 16;
}

// Staging Origin (contactUs: section 14/cms 81, privacy: section 15/cms 82, prismIntro: section 16)
if (origin === 'stgidhinstepui.dhwaniris.in') {
  baseURL = 'https://stgidhinstepapi.dhwaniris.in/web/api/';
  isShowCom = true;
  powerBIlink = 'https://app.powerbi.com/view?r=eyJrIjoiNjQzOGMzYzMtMDdmYi00YmNiLThmNDYtYmM0YTg4Y2JjMTExIiwidCI6IjZiZTk4NzZkLTI0NzAtNDJjYi05ZjQyLTA2MDQ1NGZhYjUzZCJ9';
  contactUsSectionId = 14;
  privacyStatementSectionId = 15;
  prismIntroSectionId = 16;
}

// Production Origin — set section ids after seed on prod
if (origin === 'www.app.idh-prism.org' || origin === 'app.idh-prism.org') {
  baseURL = 'https://api.idh-prism.org/web/api/';
  powerBIlink = 'https://app.powerbi.com/view?r=eyJrIjoiNTU1MmNkZDItOTIzNy00YTZjLTg0MTUtNjZhMDM4MWE1YmViIiwidCI6IjZhZTM0N2ExLTVlM2MtNDNkZS1iMjE5LTc4NWJkYWRmZDNmYiIsImMiOjh9';
  contactUsSectionId = null;
  privacyStatementSectionId = null;
  prismIntroSectionId = null;
}

export const environment = {
  production: true,
  url2: baseUri2,
  baseURL,
  secratKey,
  captchaSecretKet,
  isShowCom,
  powerBIlink,
  contactUsSectionId,
  privacyStatementSectionId,
  prismIntroSectionId
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
